import { isStagingOrDev } from "app-config";

/**
 * The Chargebee site is determined by the runtime environment, never by the
 * user record. A staging build always opens skedsocial-test; a production
 * build always opens skedsocial. Reading user.gateway is a legacy pattern
 * that broke staging users whose record was created against the prod gateway
 * (the hosted-page modal silently fails when iframe origin and CB site
 * mismatch).
 */
export type ChargebeeSite = "skedsocial-test" | "skedsocial";

export function resolveChargebeeSite(): ChargebeeSite {
  return isStagingOrDev() ? "skedsocial-test" : "skedsocial";
}
